export const environment = {
  production: false,
  //Ristoclic Test
  /*firebase: {
    apiKey: "AIzaSyCPUk6T7YscgMccOu2HDpO1tEz4ujQezUg",
    authDomain: "ristoclic-test.firebaseapp.com",
    projectId: "ristoclic-test",
    storageBucket: "ristoclic-test.appspot.com",
    messagingSenderId: "3284108004",
    appId: "1:3284108004:web:75cdff142190883ca8e2f1"
  }*/
  //Michele 40

  firebase : {
    apiKey: "AIzaSyDndXKz1WmeweO8hnZVQR6dV0lL4rRkN94",
    authDomain: "michele-4-0.firebaseapp.com",
    projectId: "michele-4-0",
    storageBucket: "michele-4-0.appspot.com",
    messagingSenderId: "177694569735",
    appId: "1:177694569735:web:1a439fd70f7b538061c1a2"
  }
};